import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { ThinkingSteps } from '@landtrustinc/design-system';
import {
  buildCheckoutSubmitSteps,
  isCheckoutSubmitInProgress,
} from '../../util/checkoutSubmitProgress';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import { Modal } from '..';

import css from './CheckoutSubmitOverlay.module.css';

const CHECKOUT_SUBMIT_MODAL_ID = 'CheckoutSubmitProgressModal';

const CheckoutSubmitOverlayComponent = ({
  intl,
  phase,
  includeLtPlus,
  onManageDisableScrolling,
}) => {
  const isOpen = isCheckoutSubmitInProgress(phase);

  useEffect(() => {
    onManageDisableScrolling(CHECKOUT_SUBMIT_MODAL_ID, isOpen);

    return () => {
      onManageDisableScrolling(CHECKOUT_SUBMIT_MODAL_ID, false);
    };
  }, [isOpen, onManageDisableScrolling]);

  if (!isOpen) {
    return null;
  }

  const steps = buildCheckoutSubmitSteps({
    phase,
    includeLtPlus,
    stepLabels: {
      creatingMembership: intl.formatMessage({
        id: 'CheckoutSubmitOverlay.stepCreatingMembership',
      }),
      confirmingMembership: intl.formatMessage({
        id: 'CheckoutSubmitOverlay.stepConfirmingMembership',
      }),
      confirmingPayment: intl.formatMessage({
        id: 'CheckoutSubmitOverlay.stepConfirmingPayment',
      }),
      submittingOrder: intl.formatMessage({
        id: 'CheckoutSubmitOverlay.stepSubmittingOrder',
      }),
    },
  });

  return (
    <Modal
      id={CHECKOUT_SUBMIT_MODAL_ID}
      isOpen={isOpen}
      onClose={() => {}}
      dontCloseOnOutsideClick
      noCloseBtn
      scrollLayerClassName={css.modalScrollLayer}
      containerClassName={css.modalContainer}
      contentClassName={css.modalContent}
    >
      <ThinkingSteps
        className={css.thinkingSteps}
        title={intl.formatMessage({ id: 'CheckoutSubmitOverlay.title' })}
        steps={steps}
        estimatedTime={intl.formatMessage({ id: 'CheckoutSubmitOverlay.estimatedTime' })}
      />
      <p className={css.disclaimer}>
        <FormattedMessage id="CheckoutSubmitOverlay.paymentDisclaimer" />
      </p>
    </Modal>
  );
};

CheckoutSubmitOverlayComponent.propTypes = {
  intl: intlShape.isRequired,
  phase: PropTypes.string.isRequired,
  includeLtPlus: PropTypes.bool.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
};

const CheckoutSubmitOverlay = connect(
  null,
  dispatch => ({
    onManageDisableScrolling: (componentId, disableScrolling) =>
      dispatch(manageDisableScrolling(componentId, disableScrolling)),
  })
)(injectIntl(CheckoutSubmitOverlayComponent));

export default CheckoutSubmitOverlay;
